import React, { useEffect, useState } from 'react'

let productionPopupRequest

export const preloadProductionPopup = () => {
  if (!productionPopupRequest) productionPopupRequest = import('./ProductionPopup')
  return productionPopupRequest
}

const DeferredProductionPopup = props => {
  const [Popup, setPopup] = useState(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    let active = true
    preloadProductionPopup()
      .then(module => {
        if (active) setPopup(() => module.default)
      })
      .catch(() => {
        productionPopupRequest = null
        if (active) setFailed(true)
      })
    return () => { active = false }
  }, [])

  if (failed) return <div role='alert'>The Event Builder could not load. Please close this window and try again.</div>
  if (!Popup) return <div role='status' aria-live='polite'>Loading event builder…</div>
  return <Popup {...props} />
}

export default DeferredProductionPopup
